import React from 'react'

const IconClose4 = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'>
      <path
        d='M6.75312 13.7275L6.27249 13.2469L9.49833 10L6.27249 6.77396L6.75312 6.29333L9.99999 9.51917L13.226 6.29333L13.7067 6.77396L10.4808 10L13.7067 13.2469L13.226 13.7275L9.99999 10.5017L6.75312 13.7275Z'
        fill='#095BBD'
      />
    </svg>
  )
}

export default IconClose4
